import { useCallback, useEffect, useMemo, useState } from 'react';
import useRequest from '../../../../../hooks/useRequest';
import { SubscriptionState } from '../../../types';
import StateList from './List';
import axios from 'axios';

import ServicePaths from '../../../../../bridge/utils/ServicePaths';

const SubscriptionStatesForm = () => {
  const userId = '';

  const [isLoading, setIsLoading] = useState(false);
  const [subscriptionStates, setSubscriptionStates] = useState<
    Array<SubscriptionState>
  >([]);

  const params = useMemo(() => ({ userId }), [userId]);

  const { data: subscriptionData, isValidating } = useRequest(
    ServicePaths.CONTROL.GetSubscriptionStates,
    params,
  );

  useEffect(() => {
    if (subscriptionData?.length) {
      setSubscriptionStates(subscriptionData);
      setIsLoading(false);
    }
  }, [subscriptionData]);

  const handleMove = useCallback((state: SubscriptionState) => {
    setSubscriptionStates((prev) => {
      const newList = [...prev];

      const index = newList.findIndex(
        (p) => p.subscriptionId === state.subscriptionId,
      );
      const item = newList[index];

      if (!item) {
        return prev;
      }

      const newItem = {
        ...item,
        isActive: !item.isActive,
      };

      newList.splice(index, 1, newItem);

      return newList;
    });
  }, []);

  const handleStartAll = useCallback(async () => {
    if (isLoading || isValidating) {
      return;
    }

    setIsLoading(true);

    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.ActiveAllSubscriptions,
      data: { userId },
    });

    setIsLoading(false);

    if (!data?.success) {
      return;
    }

    const newList = subscriptionStates.map((s) => ({
      ...s,
      isActive: true,
    }));

    setSubscriptionStates(newList);
  }, [isLoading, isValidating, subscriptionStates, userId]);

  const handleStopAll = useCallback(async () => {
    if (isLoading || isValidating) {
      return;
    }

    setIsLoading(true);

    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.DeactivateAllSubscriptions,
      data: { userId },
    });

    setIsLoading(false);

    if (!data?.success) {
      return;
    }

    const newList = subscriptionStates.map((s) => ({
      ...s,
      isActive: false,
    }));

    setSubscriptionStates(newList);
  }, [isLoading, isValidating, subscriptionStates, userId]);

  return (
    <StateList
      data={subscriptionStates}
      handleMove={handleMove}
      handleStartAll={handleStartAll}
      handleStopAll={handleStopAll}
      isLoading={isLoading || isValidating}
    />
  );
};

export default SubscriptionStatesForm;
